﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";

export class SingleInputRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    let isInForm = $element.closest('form').length != 0;
    let shouldHandle = $element.is('input') && $element.isEnabled() && !isInForm;
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    let name = $element.attr('name');
    let value = $element.val();

    let data = options.data;
    if (!data) {
      data = {}
      data[name] = value;
    }

    options.url = options.url || $element.data('url');
    options.data = data;

    Ajax.execute($element, options);
    return true;
  }
}
